import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DSButton from "@accredo/fe-shared/theme/components/Button.jsx";

export default function UnsavedChangesModal({
  open,
  onConfirm,
  onCancel,
  title = "Ungespeicherte Änderungen",
  message = "Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
  confirmLabel = "Seite verlassen",
  cancelLabel = "Abbrechen",
})
{
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <DSButton variant="tertiary" size="medium" onClick={onCancel}>
          {cancelLabel}
        </DSButton>
        <DSButton variant="primary" size="medium" color="error" onClick={onConfirm}>
          {confirmLabel}
        </DSButton>
      </DialogActions>
    </Dialog>
  );
}
